import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  ConfirmationModalComponent,
  ConfirmationModalDetail,
} from '../confirmation-modal/confirmation-modal.component';

@Injectable({ providedIn: 'root' })
export class ConfirmationService {
  constructor(private dialog: MatDialog) {}

  // Existing 2-button modal
  public ConfirmDecline(
    title: string,
    body: string,
    confirmText: string,
    declineText: string,
    confirmColour: 'primary' | 'accent' | 'warn',
    declineColour: 'primary' | 'accent' | 'warn',
  ): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      maxWidth: 450,
      data: new ConfirmationModalDetail(
        title,
        body,
        confirmText,
        declineText,
        confirmColour,
        declineColour,
      ),
    });

    return dialogRef.afterClosed();
  }

  // New 3-button Delete / Disable / Cancel modal
  public ConfirmDeleteDisable(
    title: string,
    body: string,
    deleteText: string,
    disableText: string,
    cancelText: string,
    deleteColour: 'primary' | 'accent' | 'warn' = 'warn',
    disableColour: 'primary' | 'accent' | 'warn' = 'accent',
    cancelColour: 'primary' | 'accent' | 'warn' = 'primary',
  ): Observable<'delete' | 'disable' | 'cancel'> {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      maxWidth: 450,
      data: new ConfirmationModalDetail(
        title,
        body,
        undefined, // confirmText
        undefined, // declineText
        undefined, // confirmColour
        undefined, // declineColour
        deleteText,
        disableText,
        cancelText,
        deleteColour,
        disableColour,
        cancelColour,
        'delete-disable' // mode for 3 buttons
      ),
    });

    return dialogRef.afterClosed();
  }
}
